import script from "./default.vue?vue&type=script&setup=true&lang=js"
export * from "./default.vue?vue&type=script&setup=true&lang=js"

import "./default.vue?vue&type=style&index=0&id=5cca38b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cca38b4"]])

export default __exports__